import { gql } from '@apollo/client';

export const UPSERT_USER_ASSOCIATED_ORGANISATION = gql`
  mutation UpsertUserAssociatedOrganisation($input: UpsertUserAssociatedOrganisationsInput!) {
    user: upsertUserAssociatedOrganisation(input: $input) {
      id
    }
  }
`;
